"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var UserIcon = function UserIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM7 8a5 5 0 1 1 10 0A5 5 0 0 1 7 8zm2.321 6.533A7.001 7.001 0 0 1 19 21a1 1 0 1 1-2 0 5 5 0 1 0-10 0 1 1 0 1 1-2 0 7 7 0 0 1 4.321-6.467z"
  }));
};
UserIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "share-user": "SharedUser__share-user__QYyY1",
  "shareUser": "SharedUser__share-user__QYyY1",
  "user-name": "SharedUser__user-name__34qqE",
  "userName": "SharedUser__user-name__34qqE",
  "user-icon": "SharedUser__user-icon__3wcyv",
  "userIcon": "SharedUser__user-icon__3wcyv",
  "removable-user": "SharedUser__removable-user__3mQ4W",
  "removableUser": "SharedUser__removable-user__3mQ4W",
  "rendered-user": "SharedUser__rendered-user__2cZh7",
  "renderedUser": "SharedUser__rendered-user__2cZh7",
  "full-name": "SharedUser__full-name__2tMU5",
  "fullName": "SharedUser__full-name__2tMU5"
}; 
require('./SharedUser.css');
var SharedUser = function SharedUser(_ref) {
  var user = _ref.user,
    isCurrentUser = _ref.isCurrentUser;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "share-user",
    className: (0, _classnames4.default)(styles.shareUser, (0, _defineProperty2.default)({}, styles.removableUser, !!user.isMarkedAsDeleted))
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    role: "presentation",
    "data-test-id": "user-icon-sharing",
    className: (0, _classnames4.default)(styles.userIcon, (0, _defineProperty2.default)({}, styles.removableUser, !!user.isMarkedAsDeleted)),
    size: 20
  }, /*#__PURE__*/_react.default.createElement(UserIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(styles.renderedUser, (0, _defineProperty2.default)({}, styles.removableUser, !!user.isMarkedAsDeleted), 'fs-block')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.fullName,
    title: "".concat(user.firstName, " ").concat(user.lastName),
    "data-test-id": "share-asset-username"
  }, user.firstName, " ", user.lastName, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.userName,
    "aria-label": user.username
  }, "(", isCurrentUser ? "that's you" : user.username, ")"))));
};
SharedUser.propTypes = {
  user: _propTypes.default.object.isRequired,
  isCurrentUser: _propTypes.default.bool
};
SharedUser.defaultProps = {
  isCurrentUser: false
};
var _default = exports.default = SharedUser;
//# sourceMappingURL=SharedUser.js.map